<template>
    <div>
        <input name="schedules" type="hidden" v-model="jsonData" />
        <div class="mb-1" v-for="schedule in schedules" :key="schedule.id" style="display: flex; align-items: center;">
            Le&nbsp;
            <select class="form-control" v-model="schedule.day_of_week">
                <option v-for="(day, i) in ['', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche']" :key="i" :value="i">{{day}}</option>
            </select>
            &nbsp;de&nbsp;
            <input type="time" v-model="schedule.open" class="form-control" />
            &nbsp;à&nbsp;
            <input type="time" v-model="schedule.close" class="form-control" />
            <a href="#" @click.prevent="duplicateSchedule(schedule)"><i class="fe fe-copy ml-1"></i></a>
            <a href="#" @click.prevent="removeSchedule(schedule)"><i class="fe fe-x-circle ml-2"></i></a>
        </div>
        <div class="text-center" style="margin-top: 10px;"><a href="#" @click.prevent="addSchedule">Ajouter un horaire</a></div>
    </div>
</template>

<script>
export default {
    props: ['data'],
    data () {
        return {
            schedules: [],
            index: 10000000,
            jsonData: '[]'
        }
    },
    methods: {
        addSchedule () {
            this.schedules.push({id: this.index++, open: '09:00', close: '18:00', day_of_week: 1});
            this.updateJsonData();
        },
        removeSchedule (index) {
            this.schedules.splice(this.schedules.indexOf(index), 1);
            this.updateJsonData();
        },
        updateJsonData () {
            this.jsonData = JSON.stringify(this.schedules);
        },
        duplicateSchedule(schedule) {
            let copy = {...schedule};
            copy.id = this.index++
            this.schedules.push(copy);
            this.updateJsonData();
        }
    },
    watch: {
        schedules: {
            deep: true,
            handler () {
                this.updateJsonData();
            }
        }
    },
    mounted () {
        this.jsonData = this.data;
        this.schedules = JSON.parse(this.data || '[]');
    }
};
</script>